/* Handler for default image */
export const defaultImageHandler = (event: any) => {
  const defaultImageURL = `${process.env.CVNA_APP_VEX_STOCK_CDN_URL}/generic_vehicle_desktop_1920x1080.png`;
  // To prevent infinite loop in case the defaultImageURL fails too
  if (event.target.src !== defaultImageURL) {
    event.target.src = defaultImageURL;
  }
};
